/*
 * leads app for pronia site
 *
 */
'use strict';

import {
    console_if_debug,
    when_available
    } from './blackmostros.method.js';
// ~ import angular from 'angular';
// ~ const angular = require('angular');

// export default obj => {
//   return new Promise((resolve, reject) => {
//     resolve(start_leads);
//     reject('bad');
//     });
// };

// ~ var _bms;

var start_leads = (function (){
    // declare a module
    var leads = angular.module('leads', []);
    var _tids = {};

    console_if_debug('Leads running...');

    // configure the module.
    leads.controller('PicksArticle', ['$scope', function($scope){

        var to_utc_datetime = function(date, type){
            var // d = new Date(),
                _re,
                // ~ _ft, notused
                // ~ _n,
                _utc0,
                // ~ _utc,
                _lan = document.getRootNode().documentElement.lang || window.navigator.userLanguage || window.navigator.language;

            // ~ _console(date, type);

            // ~ _n = d.getTimezoneOffset() / 60;
            _utc0 = new Date(
                date.getFullYear(), date.getMonth(),
                date.getDate(), date.getHours(),
                date.getMinutes(), date.getSeconds()
                );
            // ~ _utc0.setMinutes(_utc0.getMinutes() + _n);  not
            // ~ _utc = new Date(
                // ~ date.getUTCFullYear(), date.getUTCMonth(),
                // ~ date.getUTCDate(),  date.getUTCHours(),
                // ~ date.getUTCMinutes(), date.getUTCSeconds()
                // ~ );
            // ~ _utc.setMinutes(_utc.getMinutes() + _n);

            // date or time
            if (type == 0) {
                // ~ _re = _utc.toLocaleDateString(_lan);
                // ~ _re = _lan + date.toLocaleDateString(_lan);
                // ~ _re += " " + _n + Array(
                if (_lan.startsWith('es')) {
                    _re = Array(
                        ("0" + _utc0.getDate()).slice(-2),
                        ("0" + (_utc0.getMonth() + 1)).slice(-2),
                        ("0" + _utc0.getFullYear()).slice(-2)
                        // ~ ("0" + _utc0.getHours()).slice(-2),
                        // ~ ("0" + _utc0.getMinutes()).slice(-2),
                        );
                } else {
                    _re = Array(
                        ("0" + (_utc0.getMonth() + 1)).slice(-2),
                        ("0" + _utc0.getDate()).slice(-2),
                        ("0" + _utc0.getFullYear()).slice(-2)
                        );
                }
                _re = _re.join('/');

                // ~ _re += " " + Array(
                    // ~ ("0" + _utc.getDate()).slice(-2),
                    // ~ ("0" + (_utc.getMonth() + 1)).slice(-2),
                    // ~ ("" + _utc.getFullYear()).slice(-2)
                    // ~ ).join('/');

                /*
                if (_lan.startsWith('es')) {
                    _ft = '%d/%m/%y';
                } else {
                    _ft = '%m/%d/%y';
                }
                */
            } else {
                _re = Array(
                    ("0" + _utc0.getHours()).slice(-2),
                    ("0" + _utc0.getMinutes()).slice(-2)
                    ).join(':');
                // ~ _re = _utc.toLocaleTimeString(_lan, {hour: '2-digit', minute: '2-digit',}).slice(0,5);
                // ~ _re = _utc.toLocaleTimeString(_lan).slice(0,5);
                // ~ _re = _utc.toLocaleTimeString(_lan);
            }
            return _re;
            // ~ return _utc;
            };

        var millis_to_utc_date = function(millis){
            return to_utc_datetime(new Date(millis), 0);
            };

        var millis_to_utc_time = function(millis){
            return to_utc_datetime(new Date(millis), 1);
            };

        var add_table_id = function(id, lines){
          _tids[id] = lines;
          // ~ _console(_bms);
          // ~ _bms.minner.add_table_id(id, lines);
          };
        // ~ var add_table_id = _bms.minner.add_table_id;
        // ~ _console(add_table_id);
        // var add_table_id = function(id){
        //   if (_tableids.indexOf(id) == -1) {
        //     _tableids.push(id);
        //     update_buttons_for_show();
        //   }
        // }

        $scope.to_utc_datetime = to_utc_datetime;
        $scope.millis_to_utc_date = millis_to_utc_date;
        $scope.millis_to_utc_time = millis_to_utc_time;
        $scope.add_table_id = add_table_id;

        console_if_debug('Waiting for bms...');
        // ~ console.log('Waiting for bms...');
        when_available('_bms', function() {
          // ~ _bms = BlackMostros(jQuery.noConflict());
          // ~ _console(_bms, _tids);

          // ~ _console(Object.keys(_tids));

          for (var key in _tids) {
            window._bms.minner.add_table_id(key, _tids[key]);
          }

          // ~ var keys = [], i;
          // ~ for (keys[i++] in _tids){}
          // ~ _console(keys);

          // ~ $scope.add_table_id = add_table_id;
          });

        // ~ $scope.add_table_id = add_table_id;
        // ~ $scope.add_table_id = _bms.minner.add_table_id;
        // ~ $scope.add_table_id = add_table_id;

        }]);
});

window.start_leads = start_leads;

export {
    start_leads,
    }
